// Components
import Radio from '@/components/common/Radio'

// Styles

// Variables

// PropTypes
const propTypes = {}

function Item(props) {
  return <Radio {...props} />
}

Item.propTypes = propTypes

export default Item
